import { render } from "./userAdd.vue?vue&type=template&id=ca620be2&scoped=true"
import script from "./userAdd.vue?vue&type=script&lang=js"
export * from "./userAdd.vue?vue&type=script&lang=js"

import "./userAdd.vue?vue&type=style&index=0&id=ca620be2&lang=scss&scoped=true"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca620be2"]])

export default __exports__